import {LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {es_ES, NZ_I18N, NzI18nService, provideNzI18n} from 'ng-zorro-antd/i18n';
import {registerLocaleData} from '@angular/common';
import en from '@angular/common/locales/en';
import es from '@angular/common/locales/es';
import {FormsModule} from '@angular/forms';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {SharedModule} from "./shared.module";
import {AuthInterceptor, AuthModule, LogLevel} from "angular-auth-oidc-client";
import {environment} from "../environments/environment";
import {SharedComponentsModule} from "./shared/shared.module";
import {CompanyHeaderInterceptor} from "./core/interceptors/company-header.interceptor";
import {CamelCaseResponseInterceptor} from "./core/interceptors/camel-case-response.interceptor";

registerLocaleData(en);
registerLocaleData(es, 'es');

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    SharedModule,
    SharedComponentsModule,
    AuthModule.forRoot({
      config: {
        authority: environment.production ? 'https://sso.mojito360.com/' : 'https://sso.pre.mojito360.com/',
        redirectUrl: window.location.origin + '/auth/callback',
        postLogoutRedirectUri: window.location.origin,
        clientId: 'cecbi_web',
        scope: 'cecbi_api openid profile email offline_access',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        renewTimeBeforeTokenExpiresInSeconds: 120,
        triggerRefreshWhenIdTokenExpired: true,
        silentRenewTimeoutInSeconds: 30,
        refreshTokenRetryInSeconds: 2,
        logLevel: environment.production ? LogLevel.None : LogLevel.Debug,
        secureRoutes: [environment.baseBackendUrl],
      }
    }),
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'es'},
    {provide: NZ_I18N, useValue: 'es_ES'},
    provideNzI18n(es_ES),
    provideAnimationsAsync(),
    // Interceptors
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: CompanyHeaderInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: CamelCaseResponseInterceptor, multi: true},
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private i18n: NzI18nService) {
    // Configurar primer día de la semana globalmente
    this.configureFirstDayOfWeek();
  }

  private configureFirstDayOfWeek() {
    // Configurar el locale de ng-zorro-antd para español
    this.i18n.setLocale(es_ES);
  }
}
